/* ---------------------------------------------------------
   SALEEQA - FRONT / BACK GRID TOGGLE

   Swaps every product card in a collection grid between its
   front image and a back view. The back URL is written onto
   each card by product-item.liquid, matched from alt text.

   Cards with no back shot stay on the front, so the toggle
   degrades quietly rather than breaking.

   Choice is remembered for the session.
   --------------------------------------------------------- */

(function () {
  'use strict';

  var KEY = 'slqa-grid-view';
  var state = 'front';

  try {
    state = sessionStorage.getItem(KEY) || 'front';
  } catch (e) {}

  function cards() {
    return document.querySelectorAll('.ProductItem[data-slqa-front]');
  }

  function applyTo(card) {
    var img = card.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    if (!img) return;

    var wantBack = state === 'back' && card.getAttribute('data-slqa-back');
    var url = wantBack ? card.getAttribute('data-slqa-back') : card.getAttribute('data-slqa-front');
    var alt = wantBack ? card.getAttribute('data-slqa-back-alt') : card.getAttribute('data-slqa-front-alt');
    if (!url) return;

    /* Lazysizes builds srcset from data-src and data-widths.
       Clearing those and setting src directly stops it
       overwriting our choice on the next scroll. */
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-widths');
    img.setAttribute('sizes', '');
    img.src = url;
    if (alt) img.alt = alt;

    card.setAttribute('data-slqa-view', wantBack ? 'back' : 'front');
  }

  function applyAll() {
    Array.prototype.forEach.call(cards(), applyTo);
    document.body.classList.toggle('slqa-back-view', state === 'back');
    syncButtons();
  }

  function syncButtons() {
    var wrap = document.querySelector('[data-slqa-view-toggle]');
    if (!wrap) return;
    Array.prototype.forEach.call(wrap.querySelectorAll('button'), function (b) {
      var on = b.getAttribute('data-view') === state;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function setState(next) {
    if (next === state) return;
    state = next;
    try { sessionStorage.setItem(KEY, state); } catch (e) {}
    applyAll();
  }

  function anyBacks() {
    return document.querySelector('.ProductItem[data-slqa-back]') !== null;
  }

  function buildToggle() {
    if (document.querySelector('[data-slqa-view-toggle]')) return;
    if (!anyBacks()) return;

    var group = document.querySelector('.CollectionToolbar__Group');
    var bar = document.querySelector('.CollectionToolbar');
    var host = group || bar;
    if (!host) return;

    var wrap = document.createElement('div');
    wrap.className = 'SlqaViewToggle';
    wrap.setAttribute('data-slqa-view-toggle', '');
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Show front or back of garment');
    wrap.innerHTML =
      '<button type="button" data-view="front">Front</button>' +
      '<button type="button" data-view="back">Back</button>';

    wrap.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button[data-view]') : null;
      if (!b) return;
      e.preventDefault();
      setState(b.getAttribute('data-view'));
    });

    host.appendChild(wrap);
    syncButtons();
  }

  function init() {
    buildToggle();
    if (state === 'back') applyAll();
  }

  window.addEventListener('load', init);
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(init, 300);
    setTimeout(init, 1200);
  });

  /* Prestige loads more products over AJAX, so re-apply to any
     cards added after the first paint. */
  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(function () {
        buildToggle();
        if (state === 'back') applyAll();
      }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
